import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {UserService} from '../services/user.service';
import {MessageService} from '../services/message.service';
import {KeycloakService} from 'keycloak-angular';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(private userService: UserService,
                private messageService: MessageService,
                private keycloakService: KeycloakService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(catchError((error: HttpErrorResponse) => {
                let errorObj = error.error;
                if (errorObj instanceof ArrayBuffer) {
                    const decodedString = String.fromCharCode.apply(null, new Uint8Array(errorObj));
                    errorObj = JSON.parse(decodeURIComponent(escape(decodedString)));
                }

                if (error.status === 403) {
                    this.keycloakService.getKeycloakInstance()
                        .loadUserInfo()
                        .success(r => this.messageService.errorMessage('Você não tem permissão para acessar este recurso.'))
                        .error(e => this.messageService.invalidSessionMessage().then(x => this.userService.logout().then()));
                }
                
                return throwError(errorObj);
            }));
    }
}
